import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { isCompanyAdmin } from '../../lib/tools';
import CreateEntityButton from '../Parts/CreateEntityButton';
import { Main, Contents, ContentsTitle } from './styles/StaffTitleStyles';

/**
 * ユーザー管理画面のタイトル部分
 * 企業管理者の場合、ユーザー追加ダイアログを表示するためのボタンが表示される
 *
 * @param {Object} props
 * @param {number} props.currentUserRole - 現在ログインしているユーザーの権限
 * @param {Function} props.onOpenCreateStaffDialog - ユーザー追加ダイアログを開くための関数。
 * @returns {ReactElement}
 */
const StaffTitle = ({ currentUserRole, onOpenCreateStaffDialog }) => (
  <Main className="staffTitle">
    <Contents>
      <ContentsTitle>
        <FormattedMessage id="staff.title" />
      </ContentsTitle>
      {isCompanyAdmin(currentUserRole) && (
        <CreateEntityButton
          onCreate={onOpenCreateStaffDialog}
          labelId="common.button.add"
        />
      )}
    </Contents>
  </Main>
);

StaffTitle.propTypes = {
  currentUserRole: PropTypes.number.isRequired,
  onOpenCreateStaffDialog: PropTypes.func.isRequired,
};

export default StaffTitle;
